import { ComponentProps, forwardRef, useRef } from "react";

import { useMegaMenuData } from "@/components/mega-menu/hooks/useMegaMenuData";
import { MegaMenuMobilePanel } from "@/components/mega-menu/mobile/MegaMenuMobilePanel";
import { MenuHamburger as MenuHamburgerIcon } from "@whoppah/icons/24/MenuHamburger";

const MegaMenuMobileHamburger = forwardRef<
  HTMLButtonElement,
  ComponentProps<"button">
>((props, ref) => {
  return (
    <button
      ref={ref}
      {...props}
      aria-label="Show Menu"
      className="flex shrink-0 cursor-pointer flex-col items-center md:hidden"
    >
      <MenuHamburgerIcon />
    </button>
  );
});

/** The menu's currency picker (`MegaMenuMobileCurrencyAction`). */
const CURRENCY_ACTION = "@currency";

type MegaMenuMobileProps = {
  /**
   * The checkout's header (WHO-5143 review): no currency picker there, as on desktop. Checkout
   * charges in EUR, and switching mid-checkout would only change the converted total.
   */
  focused?: boolean;
};

export const MegaMenuMobile = ({ focused = false }: MegaMenuMobileProps) => {
  const { data } = useMegaMenuData({ mobile: true });
  const items = focused
    ? data?.items?.filter(item => !item.href?.endsWith(CURRENCY_ACTION))
    : data?.items;

  const hamburgerRef = useRef<HTMLButtonElement>(null);

  const handleClose = () => {
    if (hamburgerRef.current) {
      hamburgerRef.current.click();
    }
  };

  return (
    <MegaMenuMobilePanel
      trigger={<MegaMenuMobileHamburger ref={hamburgerRef} />}
      title="Menu"
      items={items}
      hasLocation={true}
      onClose={handleClose}
    />
  );
};
